export const PlacemarkStyle = (active) => ({
  background: 'rgb(0, 191, 255)',
  border: '4px solid white',
  borderRadius: '50%',
  boxSizing: 'border-box',
  boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.24)',
  height: '20px',
  opacity: `${active ? '0.75' : '1'}`,
  width: '20px',
})
